/** Vrai si la valeur saisie diffère de la valeur par défaut (nombres comparés en valeur, « 3.50 » = 3,5). */
export function estModifie(valeur: any, defaut: any): boolean {
  if (typeof defaut === 'boolean') return !!valeur !== defaut
  const vide = (v: any) => v === null || v === undefined || v === ''
  if (vide(valeur) || vide(defaut)) return vide(valeur) !== vide(defaut)
  const a = Number(valeur), b = Number(defaut)
  if (isNaN(a) || isNaN(b)) return String(valeur) !== String(defaut)
  return Math.abs(a - b) > 1e-9
}
